import { CardActions, CardOverflow, FormControl, FormLabel, Input } from "@mui/joy";
import { Dispatch, Fragment, useRef, useState } from "react";
import { FileUpload, FileUploadOptions } from "primereact/fileupload";
import { Avatar } from "primereact/avatar";
import { Galleria } from "primereact/galleria";
import { Tooltip } from "primereact/tooltip";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { Grid } from "@mui/material";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import {
  addDocument,
  addMetaDocument,
  updateDocument,
  updateMetaDocument,
} from "../service/documentsService";
import dayjs from "dayjs";
import { InputSwitch } from "primereact/inputswitch";

export default function DocumentDetails(modalProps: any) {
  const record = modalProps.record;
  const [name, setName] = useState(record?.name || "");
  const [nameError, setNameError] = useState(false);
  const [file, setFile] = useState(null as any);
  const [fileError, setFileError] = useState(false);
  const [checked, setChecked] = useState(false);
  const [expire, setExpire] = useState(
    (record?.expire_at ? new Date(record.expire_at) : undefined) as any
  );
  const [items, setItems] = useState([""]);

  const startOfDay = dayjs().startOf("day");

  const customBase64Uploader = async (event: any) => {
    const uploadedFile = event.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
    }
  };

  async function addUpdateDocument() {
    const errorFile = (!file || file === "") && !modalProps.id;
    setFileError(errorFile);
    if (errorFile) {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter all required fields",
        life: 3000,
      });
      return;
    }
    let params: any = {
      name: name,
    };
    if (!checked && expire) params["expire_at"] = expire;
    modalProps.setGlobalLoading(true);
    if (modalProps.id && !file) {
      updateMetaDocument(modalProps.id, params).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Document Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible?.(false);
        if (modalProps.callback) {
          modalProps.callback();
        }
        modalProps.setGlobalLoading(false);
        modalProps.setReload?.(!modalProps.reload);
      });
    } else {
      params["record_id"] = modalProps.record_id;
      params["document"] = record.document;
      addMetaDocument(record.document, params, file).then((r: any) => {
        if (modalProps.show) {
          modalProps.toast.current.show({
            severity: "success",
            summary: "Document Created Successfully",
            life: 3000,
          });
        }
        modalProps.setVisible?.(false);
        if (modalProps.callback) {
          modalProps.callback();
        }
        modalProps.setGlobalLoading(false);
        modalProps.setReload?.(!modalProps.reload);
      });
    }
  }

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormLabel style={{ marginBottom: 10 }}>
            File<div style={{ color: "red" }}>*</div>
          </FormLabel>
          <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
            <FileUpload
              mode="advanced"
              accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
              auto
              customUpload
              chooseLabel="Upload Document"
              uploadHandler={customBase64Uploader}
            />
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <FormLabel style={{ marginBottom: 10 }}>No Expiry Date</FormLabel>
          <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
            <InputSwitch checked={checked} onChange={e => setChecked(e.value)} />
          </FormControl>
        </Grid>
        {!checked ? (
          <Grid item xs={10}>
            <FormLabel style={{ marginBottom: 10 }}>Expire Date</FormLabel>
            <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
              <Calendar
                value={expire}
                onChange={e => setExpire(e.value)}
                showIcon
                minDate={new Date(startOfDay.toString())}
                dateFormat="dd-mm-yy"
              />
            </FormControl>
          </Grid>
        ) : (
          ""
        )}
      </Grid>
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{ position: "absolute", fontSize: "small", right: 0, color: "#2dd36f" }}
            onClick={() => addUpdateDocument()}
          />
        </CardActions>
      </CardOverflow>
    </Fragment>
  );
}
